module.exports = __webpack_public_path__ + "static/media/Eagle473_3c.05fa4fc0.svg";